import { CardMedia } from '@mui/material';
import React from 'react';

export default function RemainingKPIBi() {
  return (
    <CardMedia
      component="iframe"
      src="https://app.powerbi.com/reportEmbed?reportId=82eda1b7-d3a9-4d60-84b5-41285a8d0c4e&autoAuth=true&ctid=ab35a555-3574-4bb8-9c15-c26a9300d0ff"
      sx={{ width: '80vw', height: '80vh' }}
    ></CardMedia>
  );
}
